import React from 'react';
import { createTableElementClassName } from './tableStyles';

export const TableBody: React.FC = (props) => {
  const { children } = props;

  const className = createTableElementClassName('body');

  return <tbody className={className}>{children}</tbody>;
};
